import React from 'react';

import { useTranslation } from 'react-i18next';

import { map } from 'lodash';

import { ROUTES as GENERAL_ROUTES } from '../../../modules/general';
import { HEADER_TOOLS } from '../../../constants';

import { TypeApplicationStore } from '../../../stores/application-store';
import { injectStores } from '../../../stores/factories/store-utils';

import Button from '../button/button';
import DivButton from '../../common/legos/div-button/div-button';
import MenuDropdown from './menu-dropdown';
import SwitchLink from '../../menus/menu/switch-link/switch-link';
import ModuleExpander from '../../modules/module-expander';

import './menu-dropdown.scss';

const TOOL_NAME = HEADER_TOOLS.GET_STARTED;

const userOptionList = [
    { id: 'DOWNLOAD_LAUNCHER' },
    { id: 'FCRM_REGISTERED_PROJECTS' },
    { id: 'FCRM_PRICING' },
    { id: 'TRIAL_LICENSING' },
] as const;

function ConstructOptionList() {
    const { t } = useTranslation();
    return (
        <>
            {map(userOptionList, (option) => (
                <SwitchLink
                    akTestId={`ConstructOptionList|LinkTo|GENERAL|${option.id}`}
                    className='link__dropdown'
                    to={{ module: 'GENERAL', subModule: option.id }}
                    key={`current-user-drop-down-general-${option.id}`}
                >
                    <div>{t(GENERAL_ROUTES?.[option.id]?.i18nId)}</div>
                </SwitchLink>
            ))}
        </>
    );
}

export interface Props {
    ApplicationStore: TypeApplicationStore;
    isMobileMenu?: boolean;
    className?: string;
}

function GetStartedDropdown(props: Props) {
    const { t } = useTranslation();
    const {
        ApplicationStore: {
            headerTools: { openedHeaderTool },
            showToolInHeader,
        },
        isMobileMenu = false,
        className = '',
    } = props;

    const isActiveTool = openedHeaderTool === TOOL_NAME;

    return (
        <div className={'get-started ' + className}>
            <MenuDropdown
                optionsComponents={<ConstructOptionList />}
                showOpenList={isActiveTool}
                rightAlign
                actionOpenList={() => showToolInHeader(TOOL_NAME)}
            >
                <div className={'get-started-dropdown' + (isMobileMenu ? ' mobile-menu-item' : '')}>
                    {!isMobileMenu && (
                        <Button
                            id='get-started|drop-down-open-close'
                            label={t('buttons.get-started')}
                            size='small'
                            endIcon={
                                <i className='material-icons'>
                                    {isActiveTool ? 'arrow_drop_up' : 'arrow_drop_down'}
                                </i>
                            }
                            onClick={() => {
                                showToolInHeader(TOOL_NAME);
                            }}
                        />
                    )}
                    {isMobileMenu ? (
                        <>
                            <DivButton
                                className='link link_variant'
                                onClick={() => {
                                    showToolInHeader(TOOL_NAME);
                                }}
                            >
                                {t('buttons.get-started')}
                            </DivButton>
                            <ModuleExpander
                                onClick={() => {
                                    showToolInHeader(TOOL_NAME);
                                }}
                                isExpanded={isActiveTool}
                            />
                        </>
                    ) : null}
                </div>
            </MenuDropdown>
        </div>
    );
}

export default injectStores(['ApplicationStore'])(GetStartedDropdown);
